// extracted by mini-css-extract-plugin
export var lg = "_y-4";
export var md = "_y-3";
export var sm = "_y-2";
export var xs = "_y-1";
export var xxs = "_y-0";